import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=a2b825e6&scoped=true"
import script from "./PaymentsTable.vue?vue&type=script&lang=js"
export * from "./PaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=a2b825e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b825e6",
  null
  
)

export default component.exports